module.exports = __webpack_public_path__ + "static/media/facebook.892baefe.svg";